import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, switchMap } from 'rxjs';
import { CreatePublishedBoardV3$Params } from '../../api/core/fn/published-board/create-published-board-v-3';
import { CreatePublishedBoardResponse } from '../../api/core/models/api/create-published-board-response';
import { PublishedBoardService } from '../../api/core/services/published-board.service';
import { PublishedBoardsService } from '../../api/published-boards/services';
import { PreviewDashboardResolver } from '../../feature/dashboard/preview-dashboard.resolver';
import { Language } from '../../model/enums/language';
import { PublishedBoardV3Data, PublishedBoardV4Data } from './backend-published-board.types';
import { PublishedBoardV2Response } from '../../api/published-boards/models/api/published-board-v-2-response';

@Injectable({ providedIn: 'root' })
export class BackendPublishedBoardService {
  private _injector = inject(Injector);
  private _httpClient = inject(HttpClient);
  private _publishedBoardService = inject(PublishedBoardService);
  private _publishedBoardsService = inject(PublishedBoardsService);

  getPublishedBoardData(blobUrl: string): Observable<PublishedBoardV3Data | PublishedBoardV4Data> {
    return this._httpClient.get<PublishedBoardV3Data | PublishedBoardV4Data>(blobUrl);
  }

  getPublishedBoard(boardId: string): Observable<PublishedBoardV2Response> {
    return this._publishedBoardsService.getV2PublishedBoard({ boardId });
  }

  publishBoardV3(params: { body: Blob; language: Language }): Observable<CreatePublishedBoardResponse> {
    return this._publishedBoardService.createPublishedBoardV3({
      body: params.body as unknown as CreatePublishedBoardV3$Params['body'],
      'Accept-Language': params.language,
    });
  }

  publishBoardV4And5(route: ActivatedRouteSnapshot, language: Language, isV5: boolean = false): Observable<string> {
    const { boardId } = route.params;
    const previewDashboardResolver = this._injector.get(PreviewDashboardResolver);
    return previewDashboardResolver.getAdditionalData(route, isV5).pipe(
      switchMap((result) => {
        const body = {
          body: {
            boardId,
            calculations: result,
          },
          'Accept-Language': language,
        };
        if (isV5) {
          return this._publishedBoardService.createV2PublishedBoard(body).pipe(map((res) => (<any>res)?.id)); // needed since the response is types to several types, which messes up swagger codegen
        } else {
          return this._publishedBoardService.createPublishedBoard(body).pipe(map((res) => (<any>res)?.id)); // needed since the response is types to several types, which messes up swagger codegen
        }
      })
    );
  }
}
